import React, { useEffect, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Header from './../../compoments/Header';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import api from './../../services/axios'
import AlertDialog from './../../compoments/AlertDialog'
import ImageUpload from './../../compoments/ImageUpload'
import Loading from './../../compoments/Loading'
import Typography from '@material-ui/core/Typography';
import { Breadcrumbs } from '@material-ui/core';
import { Link } from 'react-router-dom'
import { Redirect } from 'react-router'
import Select from '@material-ui/core/Select'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Checkbox from '@material-ui/core/Checkbox'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemText from '@material-ui/core/ListItemText'
import Input from '@material-ui/core/Input'

import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import OutlinedInput from '@material-ui/core/OutlinedInput';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  appBarSpacer: theme.mixins.toolbar,
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  disabled: {
    padding: 30,
    backgroundColor: 'red'
  }
}));

export default function AttendancePauseUpdate({ match, history }) {

  const rota = 'attendance-pause';
  const roleName = 'Motivos de pausa';

  const [redirect, setRedirect] = React.useState(false);
  const [id, setId] = React.useState('');
  const [description, setDescription] = React.useState('');
  
  const [message, setMessage] = React.useState(false);
  const [alertTitle, setAlertTitle] = React.useState('');
  const [loading, setLoading] = React.useState(true);

  const loadData = async () => {
    // const dataQ = await api.get('/v1/queue-table/')
    // setFilas(dataQ.data.data);
    setId(match.params.id)
    const data = await api.get('/v1/attendance-pause/' + match.params.id)
    setDescription(data.data.description);
    // setFilasSelected(data.data.queues.map((i)=>i.id));
    setLoading(false);
  }

  useEffect(() => {
    loadData()
  }, [])

  const save = async () => {

    const data = new FormData();
    data.append('description', description);
    data.append('_method', 'PUT')
    try {      
      const res = await api.post('/v1/attendance-pause/' + id, data, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        }
      })
      setAlertTitle('')
      history.push('/' + rota)
    } catch(error) {
      setAlertTitle('Erro')
      setMessage(error.response.data.errors[0].message || 'Erro')
    }

  }

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  const classes = useStyles();

  return (
    <div className={classes.root}>
      {redirect && <Redirect to={redirect} />}
      <CssBaseline />
      <Header titleHeader={'Editar Clientes'} />
      {/* CONTEUDO */}
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          {loading ?  <Loading /> : 
          <Grid container spacing={3}>
            {/* Recent Orders */}
            <Grid item xs={12}>
              <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" to={`/${rota}`} >
                  {roleName}
                </Link>
                <Typography color="textPrimary">Editar</Typography>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <form className={classes.form} noValidate>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        variant="outlined"
                        required
                        fullWidth
                        id="description"
                        label="Descrição"
                        name="description"
                        autoComplete="description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                      />
                    </Grid>
                    {/* <Grid item xs={12}>
                      <FormControl className={classes.formControl}>
                        <InputLabel id="demo-mutiple-checkbox-label">Filas</InputLabel>
                        <Select
                          labelId="demo-mutiple-checkbox-label"
                          id="demo-mutiple-checkbox"
                          multiple
                          value={filasSelected}
                          onChange={(e)=> { 
                            setFilasSelected(e.target.value)
                          }}
                          input={<Input />}
                          renderValue={()=>{
                            return filas.filter((f)=>filasSelected.find((fi)=>fi===f.id)).map((fm)=>fm.name).join(', ');
                          }}
                          MenuProps={MenuProps}
                        >
                          {filas.map(f => (
                            <MenuItem key={f.id} value={f.id}>
                              <Checkbox checked={filasSelected.indexOf(f.id) > -1} />
                              <ListItemText primary={f.name} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid> */}
                    <Grid item xs={6}>
                      <Button
                        onClick={() => {
                          history.push('/' + rota)
                          // setRedirect(`/${rota}`)
                        }}
                        type="button"
                        variant="contained"
                        color="default"
                        style={{ marginRight: 30 }}
                      >
                        Cancelar
                      </Button>
                      <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={save}
                      >
                        Salvar
                      </Button>
                    </Grid>
                  </Grid>
                </form>
              </Paper>
            </Grid>
          </Grid>
          }
          <AlertDialog message={message}
            onClose={() => setMessage(false)}
            title={alertTitle}
            buttonSuccessText={'OK'}
          />
        </Container>
      </main>
    </div>
  );
}